<template>
    <div class="p-grid">
        <div class="p-col-12 p-pt-2 p-pb-1">
            <div class="p-grid p-ai-center p-pt-1 vertical-container">
                <div class="p-col-fixed" style="width: 55px">
                    <a @click="$functions.historyBack()" style="cursor: pointer">
                        <img class="" src="assets/irinox/icons/arrow_back.svg" :alt="$t('common.arrow_left')" />
                    </a>
                </div>
                <div v-if="appliance" class="p-col">
                    <h3>{{ appliance.name ?? $functions.fixModelName(appliance.modelNumber) }} - {{ $t('details.buttons.analytics_button') }}</h3>
                </div>
                <div v-else class="p-col">
                    <h3>{{ lab.name }} - {{ $t('details.buttons.analytics_button') }}</h3>
                </div>
            </div>
            <div v-if="!serialNumber" class="p-grid">
                <div class="p-col-12">
                    <TabView @tab-change="changeGamma" class="analytics-tab">
                        <TabPanel v-for="gam in gamme" :key="gam.code">

                            <template #header>
                                <span>{{ gam.name }}</span>
                            </template>
                            <div class="p-grid p-p-2">
                                <div v-for="(data, index) in allCharts" :key="data.id" class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-6 p-xxl-4 p-p-2">
                                    <div class="single-chart card" @click="goToDetail(data.id, data.chart.type)">
                                        <label :for="index" ><b>{{ $t('analytics.' + data.id) }}</b></label>
                                        <div class="single-chart-container">
                                          <Chart v-if="data.loaded && data.chart" :type="data.chart.type" :data="$functions.extractChartData(data.chart)" :options="$functions.extractChartOptions(data.chart)" :class="[data.chart.type]"/>
                                          <Skeleton v-else-if="!data.loaded && !data.chart"  ></Skeleton>
                                          <div v-else>{{ $t('analytics.no_data_week') }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    </TabView>
                </div>
            </div>
            <div v-else class="p-grid">
                <div v-if="role != 'USER'" class="p-col-12">
                    <TabView @tab-change="changeCategory" class="analytics-tab">
                        <TabPanel v-for="cat in categories" :key="cat.code">
                            <template #header>
                                <span>{{ $t('analytics.cat_' + cat.name) }}</span>
                            </template>
                            <h5>{{ $t('analytics.days_cat_'+daysCat[selectedCat]) }}</h5>
                            <div class="p-grid p-p-2">
                                <div v-for="(data, index) in allCharts" :key="data.id" class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-6 p-xxl-4 p-p-2">
                                    <div class="single-chart card" @click="goToDetail(data.id, data.chart.type)">
                                        <label :for="index"><b>{{ $t('analytics.' + data.id) }}</b></label>
                                        <div class="single-chart-container">
                                          <Chart v-if="data.loaded && data.chart" :type="data.chart.type" :data="$functions.extractChartData(data.chart)" :options="$functions.extractChartOptions(data.chart)" :class="[data.chart.type]"/>
                                          <Skeleton v-else-if="!data.loaded && !data.chart"  ></Skeleton>
                                          <div v-else>{{ $t('analytics.no_data_period') }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    </TabView>
                </div>
                <div v-else v-for="(data, index) in allCharts" :key="data.id" class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-6 p-xxl-4 p-p-2">
                    <div class="single-chart card" @click="goToDetail(data.id, data.chart.type)">
                        <label :for="index"><b>{{ $t('analytics.' + data.id) }}</b></label>
                        <div class="single-chart-container">
                          <Chart v-if="data.loaded && data.chart" :type="data.chart.type" :data="$functions.extractChartData(data.chart)" :options="$functions.extractChartOptions(data.chart)" :class="[data.chart.type]"/>
                          <Skeleton v-else-if="!data.loaded && !data.chart" ></Skeleton>
                          <div v-else>{{ $t('analytics.no_data_week') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <IrinoxDialogDark :visible="dialog.blockingError" mode="error" :message="$t('userinfo.error_dialog')" :life="3000" @update:visible="dialog.blockingError = $event" />
</template>


<script>
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import AnalyticsService from '../../service/AnalyticsService';
import { mapGetters } from 'vuex';
import 'chartjs-adapter-moment';
import ApplianceService from '../../service/ApplianceService';

export default {
    components: {
        IrinoxDialogDark,
    },
    data() {
        return {
            serialNumber: this.$route.params.serialNumber ? this.$route.params.serialNumber : null,
            labId: this.$route.params.labId ? this.$route.params.labId : null,
            remoteChartsIdByGamma: null,
            gamme: null,
            selectedGamma: "MF Next",
            remoteChartsIdByCategory: null,
            categories: null,
            selectedCat: null,
            daysCat: {
              // regulation: 1,
              // trend: 1,
              // advanced: 1,
              // relay: 1,
              // state: 7,
              // counter: 1,
              // maintenance: 1,
              // cycle: 7,
              // light: 7
              statuses: 7,
              temperature: 7,
              humidity: 7,
              other: 7
            },
            orderCat: {"statuses":0,"temperature":1,"humidity":2,"other":3},
            analyticsService: null,
            applianceService: null,
            chartsOptions: {
                bar: {
                    animation: false,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            labels: {
                                color: '#495057',
                            },
                        },
                    },
                    scales: {
                        x: {
                            ticks: {
                                color: '#495057',
                            },
                            grid: {
                                color: '#ebedef',
                            },
                        },
                        y: {
                            ticks: {
                                color: '#495057',
                            },
                            grid: {
                                color: '#ebedef',
                            },
                            title: {
                                display: false,
                                text: '',
                            },
                        },
                    },
                },
                doughnut: {
                    animation: false,
                    maintainAspectRatio: true,
                    aspectRatio: 1,
                    plugins: {
                        legend: {
                            labels: {
                                color: '#495057',
                            },
                        },
                        colors: {
                            enable: true
                        },
                        emptyDoughnut: {
                            color: 'rgba(255, 128, 0, 0.5)',
                            width: 2,
                            radiusDecrease: 20
                        }
                    },
                },
                line: {
                    animation: false,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            labels: {
                                color: '#495057',
                            },
                        },
                        // decimation: {
                        //     enabled: true,
                        //     algorithm: 'lttb',
                        //     samples: 50
                        // },
                    },
                    scales: {
                        x: {
                            type: 'time',
                            time: {
                                unit: 'day',
                                displayFormats: {
                                    day: 'YYYY/MM/DD',
                                },
                            },
                            ticks: {
                                color: '#495057',
                                callback: function (value) {
                                    return this.$d(new Date(value), 'shortNumeric');
                                }.bind(this),
                            },
                            grid: {
                                color: '#ebedef',
                            },
                        },
                        y: {
                            title: {
                                display: true,
                                text: '°C',
                            },
                            ticks: {
                                color: '#495057',
                            },
                            grid: {
                                color: '#ebedef',
                            },
                        },
                    },
                },
                stepped: {
                    animation: false,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            labels: {
                                color: '#495057',
                            },
                        },
                        // decimation: {
                        //     enabled: true,
                        //     algorithm: 'lttb',
                        //     samples: 50
                        // },
                    },
                    scales: {
                        x: {
                            type: 'time',
                            time: {
                                unit: 'day',
                                displayFormats: {
                                    day: 'YYYY/MM/DD',
                                },
                            },
                            ticks: {
                                color: '#495057',
                                callback: function (value) {
                                    return this.$d(new Date(value), 'shortNumeric');
                                }.bind(this),
                            },
                            grid: {
                                color: '#ebedef',
                            },
                        },
                        y: {
                            title: {
                                display: true,
                                text: '°C',
                            },
                            ticks: {
                                color: '#495057',
                            },
                            grid: {
                                color: '#ebedef',
                            },
                        },
                    },
                },
            },
            allCharts: null,
            dialog: {
                blockingError: false,
            },
            lineChartCount: 0
        };
    },
    computed: {
        ...mapGetters({
            personaltoken: 'userdata/personaltoken',
            is24hour: 'userdata/is24hour',
            role: 'userdata/role',
        }),
        appliance: function () {
            if (this.serialNumber) {
                return this.$store.getters['appliances/appliance'](this.serialNumber);
            } else {
                return null;
            }
        },
        lab: function () {
            if (this.labId) {
                return this.$store.getters['appliances/lab'](this.labId);
            } else {
                return null;
            }
        },
    },
    created() {
        this.analyticsService = new AnalyticsService();
        this.applianceService = new ApplianceService();
    },
    mounted() {
        // if (this.labId) {
        //     this.getGamme();
        // }
        this.getChartsIds();
    },
    methods: {
        dynamicColors(index) {
            // var r = Math.floor(Math.random() * 255);
            // var g = Math.floor(Math.random() * 255);
            // var b = Math.floor(Math.random() * 255);
            // return ['rgb(' + r + ',' + g + ',' + b + ')', 'rgb(' + r + ',' + g + ',' + b + ', 0.8)'];
            return this.$functions.getColorByIdFromPalette(index);
        },
        changeGamma(gam) {
            this.selectedGamma = this.gamme[gam.index].code;
            let chartsIds = this.remoteChartsIdByGamma[this.selectedGamma];
            this.allCharts = [];
            chartsIds.forEach(chartId => {
                let chartObj = {
                    loaded: false,
                    id: chartId,
                    chart: null
                }
                this.allCharts.push(chartObj);
            });
            this.getChartsData();
        },
        changeCategory(cat) {
            this.selectedCat = this.categories[cat.index].code;
            let chartsIds = this.remoteChartsIdByCategory[this.selectedCat];
            this.allCharts = [];
            chartsIds.forEach(chartId => {
                let chartObj = {
                    loaded: false,
                    id: chartId,
                    chart: null
                }
                this.allCharts.push(chartObj);
            });
            this.getChartsData();
        },
        goToDetail(idChart, chartType) {
            if (this.serialNumber) {
                this.$router.push({ name: 'appliance-analytics-detail', params: { serialNumber: this.appliance.serialNumber, idChart: idChart, chartType: chartType } });
            } else {
                this.$router.push({ name: 'lab-analytics-detail', params: { labId: this.labId, gamma: this.selectedGamma, idChart: idChart, chartType: chartType } });
            }
        },
        dateToStringFormat(dateValue, stringFormat) {
            return this.$moment(dateValue).format(stringFormat);
        },
        getChartsIds() {
            this.allCharts = [];
            if (this.serialNumber) {
                if (this.role != "USER") {
                    this.analyticsService
                        .getAllServiceChartsId(this.personaltoken, this.serialNumber)
                        .then((respServChartsIds) => {
                            // TODO manipulation
                            if (respServChartsIds.body && respServChartsIds.code == "200") {
                                this.remoteChartsIdByCategory = respServChartsIds.body;
                                this.categories = [];
                                Object.keys(this.remoteChartsIdByCategory).forEach(cat => {
                                    this.categories.push({
                                        name: cat,
                                        code: cat,
                                        order: this.orderCat[cat]
                                    });

                                });
                                this.categories.sort((a, b) => this.$functions.compareNumbers(b, a, "order"));
                                this.selectedCat = this.categories[0].code;
                                let chartsIds = this.remoteChartsIdByCategory[this.selectedCat];
                                this.allCharts = [];
                                chartsIds.forEach(chartId => {
                                    let chartObj = {
                                        loaded: false,
                                        id: chartId,
                                        chart: null
                                    }
                                    this.allCharts.push(chartObj);
                                });
                                this.getChartsData();
                            } else {
                                console.error('EXCEPTION');
                                this.dialog.blockingError = true;
                                setTimeout(function () {
                                    this.$functions.historyBack();
                                }.bind(this), 3000);
                            }
                        })
                        .catch((error) => {
                            console.error('EXCEPTION ' + error);
                            this.dialog.blockingError = true;
                            setTimeout(function () {
                                this.$functions.historyBack();
                            }.bind(this), 3000);
                        });

                } else {
                    this.analyticsService
                        .getAllAdminChartsId(this.personaltoken, this.serialNumber)
                        .then((respCartsIds) => {
                            // TODO manipulation
                            if (respCartsIds.body && respCartsIds.code == "200") {
                                this.allCharts = [];
                                respCartsIds.body.forEach(adminChartId => {
                                    let chartObj = {
                                        loaded: false,
                                        id: adminChartId,
                                        chart: null
                                    }
                                    this.allCharts.push(chartObj);
                                });
                                this.getChartsData();
                            } else {
                                console.error('EXCEPTION');
                                this.dialog.blockingError = true;
                                setTimeout(function () {
                                    this.$functions.historyBack();
                                }.bind(this), 3000);
                            }
                        })
                        .catch((error) => {
                            console.error('EXCEPTION ' + error);
                            this.dialog.blockingError = true;
                            setTimeout(function () {
                                this.$functions.historyBack();
                            }.bind(this), 3000);
                        });

                }

            } else {
                this.analyticsService
                    .getLabChartsId(this.personaltoken, this.labId)
                    .then((respLabChartIds) => {

                        if (respLabChartIds.body && respLabChartIds.code == "200") {
                            this.remoteChartsIdByGamma = respLabChartIds.body;
                            this.gamme = [];
                            Object.keys(this.remoteChartsIdByGamma).forEach(gamma => {
                                this.gamme.push({
                                    name: gamma,
                                    code: gamma
                                });
                            });
                            this.gamme.sort((a, b) => this.$functions.compareStrings(a, b, "name"));
                            this.selectedGamma = this.gamme[0].code;
                            let chartsIds = this.remoteChartsIdByGamma[this.selectedGamma];
                            this.allCharts = [];
                            chartsIds.forEach(chartId => {
                                let chartObj = {
                                    loaded: false,
                                    id: chartId,
                                    chart: null
                                }
                                this.allCharts.push(chartObj);
                            });

                            this.getChartsData();
                        } else {
                            console.error('EXCEPTION');
                            this.dialog.blockingError = true;
                            setTimeout(function () {
                                this.$functions.historyBack();
                            }.bind(this), 3000);
                        }
                    })
                    .catch((error) => {
                        console.error('EXCEPTION ' + error);
                        this.dialog.blockingError = true;
                        setTimeout(function () {
                            this.$functions.historyBack();
                        }.bind(this), 3000);
                    });
            }
        },
        getChartsData() {
            let days = 7;
            if(this.selectedCat!=null && this.daysCat[this.selectedCat]!=null && this.role!=='USER') {
              days = this.daysCat[this.selectedCat];
            }
            let startDate = this.dateToStringFormat(this.$moment().subtract(days, 'days'), 'YYYY-MM-DD');
            let endDate = this.dateToStringFormat(this.$moment(), 'YYYY-MM-DD');
            this.lineChartCount = 0;
            this.allCharts.forEach((singleChart, index) => {
                console.log('Index: ' + index + ' Value: ' + singleChart.id);
                this.allCharts[index].loaded = false;

                if (this.serialNumber) {
                    if (this.role != "USER") {
                        this.analyticsService
                            .getServiceChartsById(this.personaltoken, this.serialNumber, startDate, endDate, singleChart.id)
                            .then((chart) => {
                                if (chart.body && chart.code == "200") {
                                    this.allCharts[index].chart = chart.body;
                                    this.populateChart(index);
                                } else {
                                    console.error('EXCEPTION');
                                    this.allCharts[index].loaded = true;
                                }
                            })
                            .catch((error) => {
                                console.error('EXCEPTION ' + error);
                                this.allCharts[index].loaded = true;
                            });
                    } else {
                        this.analyticsService
                            .getAdminChartsById(this.personaltoken, this.serialNumber, startDate, endDate, singleChart.id)
                            .then((chart) => {
                                if (chart.body && chart.code == "200") {
                                    this.allCharts[index].chart = chart.body;
                                    this.populateChart(index);
                                } else {
                                    console.error('EXCEPTION');
                                    this.allCharts[index].loaded = true;
                                }
                            })
                            .catch((error) => {
                                console.error('EXCEPTION ' + error);
                                this.allCharts[index].loaded = true;
                            });
                    }
                } else {
                    this.analyticsService
                        .getLabChartsById(this.personaltoken, this.labId, startDate, endDate, this.selectedGamma, singleChart.id)
                        .then((chart) => {
                            if (chart.body && chart.code == "200") {
                                this.allCharts[index].chart = chart.body;
                                this.populateLabChart(index);
                            } else {
                                console.error('EXCEPTION');
                                this.allCharts[index].loaded = true;
                            }
                        })
                        .catch((error) => {
                            console.error('EXCEPTION ' + error);
                            this.allCharts[index].loaded = true;
                        });

                }
            });
        },
        ticksCallback(value) {
            if (Math.floor(value) === value) {
                return value;
            }
        },
        populateChart(indexChart) {
            /**
             * state_1
             * cycle_1
             * state_2
             * cycle_2
             * temperature_1
             * umidity_1
             * umidity_2
             * 
             * t_ambient
             * t_cell
             * t_condenser_1
             * t_condenser_2
             * level_humidity_1
             * level_humidity_2
             * percentage
             * percentage_grouped
             * sanigen
             * evap_state
             * heating_res_state
             * compressor_state
             * door_res_state
             * light_state
             * door_counter
             * door_time
             * heating_res_time
             * door_res_time
             * compressor_time
             * defrost_time
             * light_time
             * cycle_1
             * state_1
             */

            if (this.allCharts[indexChart].chart.datasets != null && this.allCharts[indexChart].chart.datasets.length>0 && this.allCharts[indexChart].chart.labels != null) {

                let chartOpt = this.$functions.clone(this.chartsOptions[this.allCharts[indexChart].chart.type]);
                this.allCharts[indexChart].chart.chartOpt = chartOpt;

                if (this.allCharts[indexChart].chart.type == 'doughnut') {
                    this.allCharts[indexChart].chart.datasets[0].data.forEach((dataDoughnut, indexDoughnut) => {
                        if (!this.allCharts[indexChart].chart.datasets[0].backgroundColor) {
                            this.allCharts[indexChart].chart.datasets[0].backgroundColor = [];
                        }
                        if (!this.allCharts[indexChart].chart.datasets[0].hoverBackgroundColor) {
                            this.allCharts[indexChart].chart.datasets[0].hoverBackgroundColor = [];
                        }
                        // console.log(dataDoughnut + indexDoughnut);
                        // let dynamicColors = this.dynamicColors();
                        this.allCharts[indexChart].chart.datasets[0].backgroundColor[indexDoughnut] = this.dynamicColors(indexDoughnut);
                        this.allCharts[indexChart].chart.datasets[0].hoverBackgroundColor[indexDoughnut] = this.dynamicColors(indexDoughnut);
                    });
                    if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MF Next') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "state_1":
                                this.allCharts[indexChart].chart.labels.forEach((label, indexLabel) => {
                                    this.allCharts[indexChart].chart.labels[indexLabel] = this.$t("mf.functions." + label);
                                });
                                break;
                            case "door_time":
                                this.allCharts[indexChart].chart.labels.forEach((label, indexLabel) => {
                                    this.allCharts[indexChart].chart.labels[indexLabel] = this.$t("details.mf.door_active_" + label);
                                });
                                break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MYA') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "state_1":
                                this.allCharts[indexChart].chart.labels.forEach((label, indexLabel) => {
                                    this.allCharts[indexChart].chart.labels[indexLabel] = this.$t("mya.functions." + label);
                                });
                                break;
                            case "cycle_1":
                                this.allCharts[indexChart].chart.labels.forEach((label, indexLabel) => {
                                    this.allCharts[indexChart].chart.labels[indexLabel] = this.$t("mya.cycles." + label.split("_")[1]);
                                });
                                break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'CONSERVATORE') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "state_1":
                                this.allCharts[indexChart].chart.labels.forEach((label, indexLabel) => {
                                    this.allCharts[indexChart].chart.labels[indexLabel] = this.$t("details.cp.mode_" + label);
                                });
                                break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'FERMALIEVITA') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "state_1":
                                this.allCharts[indexChart].chart.labels.forEach((label, indexLabel) => {
                                    this.allCharts[indexChart].chart.labels[indexLabel] = this.$t("analytics.mp." + label);
                                });
                                break;
                            case "door_time":
                                this.allCharts[indexChart].chart.labels.forEach((label, indexLabel) => {
                                    this.allCharts[indexChart].chart.labels[indexLabel] = this.$t("details.mp.door_active_" + label);
                                });
                                break;
                            default:
                                break;

                        }
                    }
                    this.allCharts[indexChart].loaded = true;
                } else if (this.allCharts[indexChart].chart.type == 'bar') {
                    this.allCharts[indexChart].chart.datasets.forEach((dataBar, indexData) => {
                        dataBar.backgroundColor = this.dynamicColors(indexData);
                    });
                    this.allCharts[indexChart].chart.labels.forEach((labelDate, indexLabelDate) => {
                        this.allCharts[indexChart].chart.labels[indexLabelDate] = this.$d(labelDate, "shortNumeric");
                    });
                    if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MF Next') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "state_2":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("mf.functions." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.title.display = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.title.text = this.allCharts[indexChart].chart.unit;
                                break;
                            case "cycle_2":
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MYA') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "state_2":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("mya.functions." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.title.display = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.title.text = this.allCharts[indexChart].chart.unit;
                                break;
                            case "cycle_2":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("mya.cycles." + dataset.label.split("_")[1]);
                                });
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                break;
                            case "defrost_time":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mya.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.title.display = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.title.text = this.allCharts[indexChart].chart.unit;
                                break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'CONSERVATORE') {
                        switch (this.allCharts[indexChart].chart.id) {
                            // case "door_counter":
                            //     this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                            //         this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.cp.status." + dataset.label);
                            //     });
                            //     this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                            //     this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                            //     break;
                            case "state_2":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("details.cp.mode_" + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.title.display = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.title.text = this.allCharts[indexChart].chart.unit;
                                break;
                            case "cycle_2":
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                break;
                            case "defrost_time":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.cp.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.title.display = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.title.text = this.allCharts[indexChart].chart.unit;
                                break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'FERMALIEVITA') {
                        switch (this.allCharts[indexChart].chart.id) {
                            // case "door_counter":
                            // case "percentage_grouped":
                            //     this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                            //         this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mp.status." + dataset.label);
                            //     });
                            //     break;
                            case "state_2":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("analytics.mp." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.title.display = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.title.text = this.allCharts[indexChart].chart.unit;
                                break;
                            case "cycle_2":
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                break;
                            default:
                                break;

                        }
                    }
                    this.allCharts[indexChart].loaded = true;
                } else if (this.allCharts[indexChart].chart.type == 'line') {


                    this.allCharts[indexChart].chart.chartOpt.scales.y.title.text = this.allCharts[indexChart].chart.unit;

                    if(this.role!='USER' && this.selectedCat!=null && this.daysCat[this.selectedCat]==1) {
                      this.allCharts[indexChart].chart.chartOpt.scales.x.time = {
                        unit: 'hour',
                        displayFormats: {
                            hour: 'HH.mm',
                        },
                      }
                    }

                    this.allCharts[indexChart].chart.datasets.forEach((valueDataset, indexDataset) => {
                        let series = [];
                        this.allCharts[indexChart].chart.datasets[indexDataset].data.forEach((valueY, indexValueY) => {
                            series.push({
                                x: this.allCharts[indexChart].chart.labels[indexValueY],
                                y: valueY,
                            });
                        });
                        this.allCharts[indexChart].chart.datasets[indexDataset].data = series;
                    });



                    if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MF Next') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "percentage":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mf.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            case "t_ambient":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mf.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            case "t_cell":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("analytics.mf.status." + dataset.label);
                                });
                                break;
                            case "t_condenser_1":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("analytics.mf.status." + dataset.label);
                                });
                                break;
                            case "t_evaporator":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mf.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MYA') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "percentage":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mya.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            case "t_cell":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("analytics.mya.status." + dataset.label);
                                });
                                break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'FERMALIEVITA') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "percentage":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mp.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            case "t_ambient":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mp.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            case "t_cell":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("analytics.mp.status." + dataset.label);
                                });
                                break;
                            case "t_condenser_1":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mp.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            case "t_evaporator":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mp.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            case "level_humidity_2":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("analytics.mp.status." + dataset.label);
                                });
                                break;
                            // case "temperature_1":
                            // case "compressor_state":
                            // case "heating_res_state":
                            // case "door_res_state":
                            // case "level_humidity_2":
                            // case "t_condenser_2":
                            // case "sanigen":
                            // case "evap_state":
                            // case "humidity_2":
                            //     this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                            //         this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mp.status." + dataset.label);
                            //     });
                            //     break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'CONSERVATORE') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "percentage":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.cp.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            // case "temperature_1":
                            case "t_condenser_1":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.cp.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            case "t_cell":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("analytics.cp.status." + dataset.label);
                                });
                                break;
                            case "t_evaporator":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.cp.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            default:
                                break;
                        }
                    }
                    this.allCharts[indexChart].chart.datasets.forEach((dataLine, indexLineSeries) => {
                        dataLine.borderColor = this.dynamicColors(indexLineSeries);
                        this.lineChartCount++;
                        dataLine.fill = false;
                        // dataLine.tension = 0.4;
                    });
                    this.allCharts[indexChart].loaded = true;
                } else if (this.allCharts[indexChart].chart.type == 'stepped') {

                    this.allCharts[indexChart].chart.type = "line";
                    let chartOpt = this.$functions.clone(this.chartsOptions[this.allCharts[indexChart].chart.type]);
                    this.allCharts[indexChart].chart.chartOpt = chartOpt;
                    this.allCharts[indexChart].chart.chartOpt.scales.y.title.text = this.allCharts[indexChart].chart.unit;

                    if(this.role!='USER' && this.selectedCat!=null && this.daysCat[this.selectedCat]==1) {
                      this.allCharts[indexChart].chart.chartOpt.scales.x.time = {
                        unit: 'hour',
                        displayFormats: {
                            hour: 'HH.mm',
                        },
                      }
                    }

                    this.allCharts[indexChart].chart.datasets.forEach((valueDataset, indexDataset) => {
                        let series = [];
                        this.allCharts[indexChart].chart.datasets[indexDataset].data.forEach((valueY, indexValueY) => {
                            series.push({
                                x: this.allCharts[indexChart].chart.labels[indexValueY],
                                y: valueY,
                            });
                        });
                        this.allCharts[indexChart].chart.datasets[indexDataset].data = series;
                    });
                    if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MF Next') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "sanigen":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mf.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            // case "compressor_state":
                            // case "heating_res_state":
                            // case "door_res_state":
                            // case "evap_state":
                            //     this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                            //         this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mf.status." + dataset.label);
                            //     });
                            //     break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'ABBATTITORE' && this.appliance.gamma == 'MYA') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "sanigen":
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            // case "heating_res_state":
                            // case "compressor_state":
                            // case "door_res_state":
                            // case "evap_state":
                            //     this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                            //         this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mya.status." + dataset.label);
                            //     });
                            //     break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'FERMALIEVITA') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "sanigen":
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            case "level_humidity_1":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("analytics.mp.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                break;
                            // case "humidity_1":
                            // case "temperature_1":
                            // case "compressor_state":
                            // case "heating_res_state":
                            // case "door_res_state":
                            // case "evap_state":
                            // case "level_humidity_1":
                            // case "light_state":
                            // case "t_cell":
                            // case "humidity_2":
                            //     this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                            //         this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.mp.status." + dataset.label);
                            //     });
                            //     break;
                            default:
                                break;

                        }
                    } else if (this.appliance.type == 'CONSERVATORE') {
                        switch (this.allCharts[indexChart].chart.id) {
                            // case "sanigen":
                            //     this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                            //         this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.cp.status." + dataset.label);
                            //     });
                            //     this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                            //     this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                            //     this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                            //     break;
                            case "level_humidity_1":
                                this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                                    this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("analytics.cp.status." + dataset.label);
                                });
                                this.allCharts[indexChart].chart.chartOpt.scales.y.beginAtZero = true;
                                this.allCharts[indexChart].chart.chartOpt.scales.y.ticks.callback = this.ticksCallback;
                                this.allCharts[indexChart].chart.chartOpt.plugins.legend.display = false;
                                break;
                            // case "light_state":
                            // case "evap_state":
                            // case 'door_res_state':
                            // case "level_humidity_1":
                            // case "compressor_state":
                            // case "humidity_1":
                            //     this.allCharts[indexChart].chart.datasets.forEach((dataset, indexDataset) => {
                            //         this.allCharts[indexChart].chart.datasets[indexDataset].label = this.$t("extra.cp.status." + dataset.label);
                            //     });
                            //     break;
                            default:
                                break;
                        }
                    }

                    this.allCharts[indexChart].chart.datasets.forEach((dataLine, indexLineSeries) => {
                        dataLine.borderColor = this.dynamicColors(indexLineSeries);
                        this.lineChartCount++;
                        dataLine.fill = false;
                        dataLine.stepped = "before";
                    });
                    this.allCharts[indexChart].loaded = true;
                }
            }
        },
        populateLabChart(indexChart) {
            /**
             * state_1
             * cycle_1
             */
            if (this.allCharts[indexChart].chart.datasets != null && this.allCharts[indexChart].chart.datasets.length>0 && this.allCharts[indexChart].chart.labels != null) {

                let chartOpt = this.$functions.clone(this.chartsOptions[this.allCharts[indexChart].chart.type]);
                this.allCharts[indexChart].chart.chartOpt = chartOpt;

                if (this.allCharts[indexChart].chart.type == 'doughnut') {
                    this.allCharts[indexChart].chart.datasets[0].data.forEach((dataDoughnut, indexDoughnut) => {
                        if (!this.allCharts[indexChart].chart.datasets[0].backgroundColor) {
                            this.allCharts[indexChart].chart.datasets[0].backgroundColor = [];
                        }
                        if (!this.allCharts[indexChart].chart.datasets[0].hoverBackgroundColor) {
                            this.allCharts[indexChart].chart.datasets[0].hoverBackgroundColor = [];
                        }
                        // console.log(dataDoughnut + indexDoughnut);
                        // let dynamicColors = this.dynamicColors();
                        this.allCharts[indexChart].chart.datasets[0].backgroundColor[indexDoughnut] = this.dynamicColors(indexDoughnut);
                        this.allCharts[indexChart].chart.datasets[0].hoverBackgroundColor[indexDoughnut] = this.dynamicColors(indexDoughnut);
                    });
                    if (this.selectedGamma == 'MF Next') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "state_1":
                                this.allCharts[indexChart].chart.labels.forEach((label, indexLabel) => {
                                    this.allCharts[indexChart].chart.labels[indexLabel] = this.$t("mf.functions." + label);
                                });
                                break;
                            case "cycle_1":
                                console.log("cycle 1 doughnut");
                                break;
                            default:
                                break;

                        }
                        this.allCharts[indexChart].loaded = true;
                    } else if (this.selectedGamma == 'MYA') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "state_1":
                                this.allCharts[indexChart].chart.labels.forEach((label, indexLabel) => {
                                    this.allCharts[indexChart].chart.labels[indexLabel] = this.$t("mya.functions." + label);
                                });
                                break;
                            case "cycle_1":
                                this.allCharts[indexChart].chart.labels.forEach((label, indexLabel) => {
                                    this.allCharts[indexChart].chart.labels[indexLabel] = this.$t("mya.cycles." + label.split("_")[1]);
                                });
                                break;
                            default:
                                break;

                        }
                        this.allCharts[indexChart].loaded = true;
                    } else if (this.selectedGamma == 'MP Next') {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "state_1":
                                this.allCharts[indexChart].chart.labels.forEach((label, indexLabel) => {
                                    this.allCharts[indexChart].chart.labels[indexLabel] = this.$t("details.mp." + label);
                                });
                                break;
                            default:
                                break;

                        }
                        this.allCharts[indexChart].loaded = true;
                    } else {
                        switch (this.allCharts[indexChart].chart.id) {
                            case "state_1":
                                this.allCharts[indexChart].chart.labels.forEach((label, indexLabel) => {
                                    this.allCharts[indexChart].chart.labels[indexLabel] = this.$t("details.cp.mode_" + label);
                                });
                                break;
                            default:
                                break;

                        }
                        this.allCharts[indexChart].loaded = true;
                    }
                }

            }
        }
    }
};
</script>
<style scoped>

h3 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.single-chart {
    cursor: pointer;
}
.single-chart > label {
  line-height: 1rem;
  height: 2rem;
  display: flex;
}

.analytics-tab {
    width: 100%;
}

.single-chart-container {
  margin: auto;
}
.p-chart {
  height: 400px;
}
.p-chart.doughnut {
  max-width: 400px;
  margin: auto;

}

.p-skeleton {
  padding-top: 400px;
}


</style>